module.exports = "/_next/static/images/sprite-icons-22849927dade2e5d8293163a22c1a910.svg";